import Storage from 'local-storage-fallback';

export function getItem(item) {
  return Storage.getItem(item);
}

export function getParsedItem(item) {
  return JSON.parse(getItem(item));
}

export function setItem(key, value) {
  Storage.setItem(key, value);
}

export function isKeyTimedOut(targetObject, key) {
  const storedObject = getParsedItem(targetObject) || {};
  const currentTime = new Date().getTime();
  if (!Object.keys(storedObject).includes(key)) {
    return false;
  }
  if (currentTime > storedObject[key]) {
    removekey(targetObject, key);
    return false;
  } else {
    return true;
  }
}

export function appendItem(targetObject, key, value) {
  const storedObject = getParsedItem(targetObject) || {};
  storedObject[key] = value;
  setItem(targetObject, JSON.stringify(storedObject));
}

export function removekey(targetObject, key) {
  const storedObject = getParsedItem(targetObject);
  if (storedObject) {
    delete storedObject[key];
    if (Object.keys(storedObject).length === 0) {
      Storage.removeItem(targetObject);
    } else {
      setItem(targetObject, JSON.stringify(storedObject));
    }
  }
}
